// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".big-two-map-box[data-v-472a24a2]{width:900px;height:440px;position:absolute;left:27%;top:28%}", ""]);
// Exports
module.exports = exports;
